export default __webpack_public_path__ + "static/327-e4606227396effae7dd380d8fe1c7c19.gif";